const States = [
  { region: 'us-al', state: 'Alabama' },
  { region: 'us-ak', state: 'Alaska' },
  { region: 'us-az', state: 'Arizona' },
  { region: 'us-ar', state: 'Arkansas' },
  { region: 'us-ca', state: 'California' },
  { region: 'us-co', state: 'Colorado' },
  { region: 'us-ct', state: 'Connecticut' },
  { region: 'us-de', state: 'Delaware' },
  { region: 'us-diplomat', state: 'Diplomat' },
  { region: 'us-dc', state: 'District of Columbia' },
  { region: 'us-fl', state: 'Florida' },
  { region: 'us-ga', state: 'Georgia' },
  { region: 'us-hi', state: 'Hawaii' },
  { region: 'us-id', state: 'Idaho' },
  { region: 'us-il', state: 'Illinois' },
  { region: 'us-in', state: 'Indiana' },
  { region: 'us-ia', state: 'Iowa' },
  { region: 'us-ks', state: 'Kansas' },
  { region: 'us-ky', state: 'Kentucky' },
  { region: 'us-la', state: 'Louisiana' },
  { region: 'us-me', state: 'Maine' },
  { region: 'us-md', state: 'Maryland' },
  { region: 'us-ma', state: 'Massachusetts' },
  { region: 'us-mi', state: 'Michigan' },
  { region: 'us-mn', state: 'Minnesota' },
  { region: 'us-ms', state: 'Mississippi' },
  { region: 'us-mo', state: 'Missouri' },
  { region: 'us-mt', state: 'Montana' },
  { region: 'us-ne', state: 'Nebraska' },
  { region: 'us-nv', state: 'Nevada' },
  { region: 'us-nh', state: 'New Hampshire' },
  { region: 'us-nj', state: 'New Jersey' },
  { region: 'us-nm', state: 'New Mexico' },
  { region: 'us-ny', state: 'New York' },
  { region: 'us-nc', state: 'North Carolina' },
  { region: 'us-nd', state: 'North Dakota' },
  { region: 'us-oh', state: 'Ohio' },
  { region: 'us-ok', state: 'Oklahoma' },
  { region: 'us-or', state: 'Oregon' },
  { region: 'us-pa', state: 'Pennsylvania' },
  { region: 'us-ri', state: 'Rhode Island' },
  { region: 'us-sc', state: 'South Carolina' },
  { region: 'us-sd', state: 'South Dakota' },
  { region: 'us-tn', state: 'Tennessee' },
  { region: 'us-tx', state: 'Texas' },
  { region: 'us-ut', state: 'Utah' },
  { region: 'us-us', state: 'U.S. Government' },
  { region: 'us-vt', state: 'Vermont' },
  { region: 'us-va', state: 'Virginia' },
  { region: 'us-wa', state: 'Washington' },
  { region: 'us-wv', state: 'West Virginia' },
  { region: 'us-wi', state: 'Wisconsin' },
  { region: 'us-wy', state: 'Wyoming' },
];

const MexicoStates = [
  { region: 'mx-agu', state: 'Aguascalientes' },
  { region: 'mx-bcn', state: 'Baja California' },
  { region: 'mx-bcs', state: 'Baja California Sur' },
  { region: 'mx-cam', state: 'Campeche' },
  { region: 'mx-chp', state: 'Chiapas' },
  { region: 'mx-chh', state: 'Chihuahua' },
  { region: 'mx-cmx', state: 'Ciudad de México' },
  { region: 'mx-coa', state: 'Coahuila de Zaragoza' },
  { region: 'mx-col', state: 'Colima' },
  { region: 'mx-dur', state: 'Durango' },
  { region: 'mx-gua', state: 'Guanajuato' },
  { region: 'mx-gro', state: 'Guerrero' },
  { region: 'mx-hid', state: 'Hidalgo' },
  { region: 'mx-jal', state: 'Jalisco' },
  { region: 'mx-mic', state: 'Michoacán de Ocampo' },
  { region: 'mx-mor', state: 'Morelos' },
  { region: 'mx-mex', state: 'México' },
  { region: 'mx-nay', state: 'Nayarit' },
  { region: 'mx-nle', state: 'Nuevo León' },
  { region: 'mx-oax', state: 'Oaxaca' },
  { region: 'mx-pue', state: 'Puebla' },
  { region: 'mx-que', state: 'Querétaro' },
  { region: 'mx-roo', state: 'Quintana Roo' },
  { region: 'mx-slp', state: 'San Luis Potosí' },
  { region: 'mx-sin', state: 'Sinaloa' },
  { region: 'mx-son', state: 'Sonora' },
  { region: 'mx-tab', state: 'Tabasco' },
  { region: 'mx-tam', state: 'Tamaulipas' },
  { region: 'mx-tla', state: 'Tlaxcala' },
  { region: 'mx-ver', state: 'Veracruz de Ignacio de la Llave' },
  { region: 'mx-yuc', state: 'Yucatán' },
  { region: 'mx-zac', state: 'Zacatecas' },
];

const CanadaStates = [
  { region: 'ca-ab', state: 'Alberta' },
  { region: 'ca-bc', state: 'British Columbia' },
  { region: 'ca-mb', state: 'Manitoba' },
  { region: 'ca-nb', state: 'New Brunswick' },
  { region: 'ca-nf', state: 'Newfoundland' },
  { region: 'ca-ns', state: 'Nova Scotia' },
  { region: 'ca-nt', state: 'Northwest Territories' },
  { region: 'ca-on', state: 'Ontario' },
  { region: 'ca-pe', state: 'Prince Edward Island' },
  { region: 'ca-qc', state: 'Quebec' },
  { region: 'ca-sk', state: 'Saskatchewan' },
  { region: 'ca-yt', state: 'Yukon Territory' },
];

const CentralAmericanCountries = [
  { region: 'cac-bz', state: 'Belize' },
  { region: 'cac-cr', state: 'Costa Rica' },
  { region: 'cac-cz', state: 'Canal Zone' },
  { region: 'cac-sv', state: 'El Salvador' },
  { region: 'cac-gt', state: 'Guatemala' },
  { region: 'cac-hn', state: 'Honduras' },
  { region: 'cac-ni', state: 'Nicaragua' },
  { region: 'cac-pa', state: 'Panama' },
];

const Protectorates = [
  { region: 'us-as', state: 'American Samoa' },
  { region: 'us-gu', state: 'Guam' },
  { region: 'us-mp', state: 'Northern Mariana Islands' },
  { region: 'us-pr', state: 'Puerto Rico' },
  { region: 'us-um', state: 'U.S. Minor Outlying Islands' },
  { region: 'us-vi', state: 'Virgin Islands' },
];

export const Regions = [
  { label: 'USA States', states: States },
  { label: 'Mexico States', states: MexicoStates },
  { label: 'Canada States', states: CanadaStates },
  { label: 'Central American Countries', states: CentralAmericanCountries },
  { label: 'American Possessions or Protectorates', states: Protectorates },
];
